import validation from 'dashboard/store/encounter/validation';

/**
 * Mixin encounter.mixin.js
 *
 * @module encounter
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.4] app/src/APP_DASHBOARD/mixins/encounter.mixin.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  methods: {
    setErrorMessage(field) {
      const v = this.$store.getters[`encounter/validationIssueObjects`][field];

      // Note: English by specs
      let englishOnly = false;
      switch (field) {
        case 'bodyWeight':// Vital Signs
        case 'bloodPressureSystolic':// Vital Signs
        case 'bloodPressureDiastolic':// Vital Signs
        case 'pulseRate':// Vital Signs
        case 'LDL':// Vital Signs
        case 'eGFR':// Vital Signs
        case 'isWalkingTestPerformed':// 6MWT
        case 'distanceWalked':// 6MWT
        case 'perceivedExertion':// 6MWT
        case 'notPerformedReasonGroup':// 6MWT
        case 'notPerformedReason':// 6MWT
        case 'NEW_DIAGNOSIS':// Clinical Assesment
        case 'AGE':// Clinical Assesment
        case 'DIABETES_MELLITUS_TYPE1':// Clinical Assesment
        case 'DIABETES_MELLITUS_TYPE2':// Clinical Assesment
        case 'CHRONIC_KIDNEY_DISEASE':// Clinical Assesment
        case 'HYPERTENSION':// Clinical Assesment
        case 'CEREBROVASCULAR_DISEASE':// Clinical Assesment
        case 'TIA':// Clinical Assesment
        case 'STROKE':// Clinical Assesment
        case 'CAROTID_ENDARTERECTOMY':// Clinical Assesment
        case 'PERIPHERAL_ARTERY_DISEASE':// Clinical Assesment
        case 'THROMBOEMBOLISM':// Clinical Assesment
        case 'NEW_DIAGNOSIS_HF':// Clinical Assesment
          englishOnly = true;
          break;
      }

      if (v && v.labelTranslation){
        this.errorMessages[field] = englishOnly ? this.$ucfirst(this.$t({...v.labelTranslation, language: 'en'})) : this.$ucfirst(this.$t(v.labelTranslation));
      } else if (v && v.key) {
        this.errorMessages[field] = englishOnly ? this.$ucfirst(this.$t(`validation.${v.key}`, {language: 'en'})) : this.$ucfirst(this.$t(`validation.${v.key}`));
      } else {
        this.errorMessages[field] = '';
      }
    },
    self() {
      return this;
    },
    validate() {
      const validationIssues = this.$store.getters['encounter/validationIssues'];

      Object.keys(validationIssues).forEach((key) => {
        const isCurrentPage = validation[key].page === this.$route.name;
        if (isCurrentPage && validationIssues[key]) {
          this.setErrorMessage(key)
        }
      });
    },
  },
  computed :{
    isDefaultLanguage(){
      return !this.$store.state.currentLanguage || this.$store.state.currentLanguage === 'en'
    },
    canEditVisitData(){
      return this.$store.getters['user/canEditVisitData'](this.$store.getters['encounter/versionInt'])
    }
  },
  created() {
    if (this.$store.getters['encounter/isValidationMode']) {
      this.validate();
    }

    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'encounter/switchToValidationMode') {
        this.validate();
      }
    });
  },
};
